"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorStyles = exports.styles = void 0;
exports.styles = {
    default: {
        default: 'squid-no-underline',
        hover: 'hover:squid-underline',
        active: 'active:squid-underline',
        focus: 'focus:squid-underline focus-visible:squid-underline',
        visited: 'visited:squid-underline',
    },
    underline: {
        default: 'squid-underline',
        hover: 'hover:squid-underline',
        active: 'active:squid-underline',
        focus: 'focus:squid-underline focus-visible:squid-underline',
        visited: 'visited:squid-underline',
    },
};
exports.colorStyles = {
    accent: 'squid-text-alias-color-text-link-default visited:squid-text-alias-color-text-link-visited',
    neutral: 'squid-text-alias-color-text-base visited:squid-text-alias-color-text-base',
    'neutral-weak': 'squid-text-alias-color-text-weaker visited:squid-text-alias-color-text-weaker',
    'on-neutral': 'squid-text-alias-color-text-on-neutral',
    'on-info': 'squid-text-alias-color-text-on-info-weak',
    'on-success': 'squid-text-alias-color-text-on-success-weak',
    'on-warning': 'squid-text-alias-color-text-on-attention-weak',
    'on-critical': 'squid-text-alias-color-text-on-critical-weak',
    'on-primary': 'squid-text-alias-color-text-on-primary',
    'on-primary-variant': 'squid-text-alias-color-text-on-primary-variant',
    weak: 'squid-text-alias-color-text-weak',
    weaker: 'squid-text-alias-color-text-weaker',
    weakest: 'squid-text-alias-color-text-weakest',
};
